import { useApiQuery } from '@/api/main/query'
import { TopupModel, TopupModelMerchant } from '@/entities/topup/model'
import { topupsAPI } from '../api'

export function useTopupQuery({ id }: { id: string }) {
  const queryKey = ['topup', id]

  const query = useApiQuery<TopupModel | TopupModelMerchant>(queryKey, topupsAPI.item(id))

  return {
    ...query,
    queryTopupData: query.data,
    topupError: query.error,
    topupIsLoading: query.isLoading,
    queryKey,
  }
}
